class HeaderCoveoSearch {
    constructor() {
        this.searchIconSelector = ".header-search";
        this.searchSectionSelector = ".E-search-panel";
        this.searchInputSelector = "#E-search-form__input";
        this.searchButtonSelector = "#E-search-form__button";
        this.closeIconSelector = ".E-search-panel__close";
        this.recentSearchesContainerSelector = ".E-search-panel-popular";
        this.mainNavTriggerSelector = ".E-main-nav-trigger";
        this.recentSearchesUlSelector = ".E-search-panel-popular__bd";
        this.autosuggestionContainer = "#autoSuggestionContainer";
        this.jQueryUiJsPath = "/assets/vendor/jquery/jquery-ui.min.js";
        this.jQueryUiLoaded = false;
        this.bearerToken = "";
        this.bearerTokenEndpoint = "/coveo/rest/token?t=";
        this.autoSuggestionEndpoint = "/coveo/rest/search/v2/values?sitecoreItemUri=sitecore%3A%2F%2Fweb%2F%7B[itemId]%7D%3Flang%3D[language]%26amp%3Bver%3D[version]&siteName=[siteName]";
        this.autoSuggestionBody = "field=%40doctitle&ignoreAccents=true&sortCriteria=occurrences&maximumNumberOfValues=5&patternType=Wildcards&pattern=*[term]*&queryOverride=[queryOverride]";
    }

    init() {
        this.searchIcon = document.querySelector(this.searchIconSelector);
        this.searchInput = document.querySelector(this.searchInputSelector);
        this.searchInput.value = "";
        this.searchSection = document.querySelector(this.searchSectionSelector);
        this.closeIcon = document.querySelector(this.closeIconSelector);
        this.searchButton = document.querySelector(this.searchButtonSelector);
        this.recentSearchesContainer = document.querySelector(this.recentSearchesContainerSelector);
        this.recentSearchesUl = document.querySelector(this.recentSearchesUlSelector);

        //get data attributes value
        this.searchPageUrl = this.searchSection.getAttribute("data-search-page-url");
        this.pageId = this.searchSection.getAttribute("data-page-id");
        this.pageVersion = this.searchSection.getAttribute("data-page-version");
        this.siteName = this.searchSection.getAttribute("data-site-name");
        this.query = this.searchSection.getAttribute("data-query");
        this.language = this.searchSection.getAttribute("data-language");

        this.bindEvents();
    }

    bindEvents() {
        //open search section
        this.searchIcon.addEventListener("click", (event) => {
            this.showSearchSection();
            this.getBearerToken();
            this.loadRequiredAssets();
        });

        //close search section
        this.closeIcon.addEventListener("click", () => {
            this.hideSearchSection();
        });

        //outside click event of searchSection hideSearchBox
        document.addEventListener("click", (event) => {
            //check if the event target parent doesn't contains searchSection
            if (!this.searchSection.contains(event.target) && !this.searchIcon.contains(event.target)) {
                //check if the search section is active
                if (this.searchSection.classList.contains("--is-active")) {
                    //hide the search section
                    this.hideSearchSection();
                }
            }
        });

        //search button click
        this.searchButton.addEventListener("click", (event) => {
            event.preventDefault();
            const queryText = this.searchInput.value.trim();
            this.redirectToSearchPage(queryText);
        });

        //searchbox enter key event
        this.searchInput.addEventListener("keydown", (event) => {
            if (event.key === "Enter") {
                const queryText = this.searchInput.value.trim();
                this.redirectToSearchPage(queryText);
            }
        });
    }

    // isSafeRelativeUrl function to sanitize URLs
    isSafeRelativeUrl(url) {
        // Trim whitespace
        url = url.trim();

        // Reject empty or null
        if (!url) return false;

        // Reject protocol-relative and absolute URLs
        if (/^(?:[a-z][a-z0-9+.-]*:)?\/\//i.test(url)) return false;

        // Reject URLs with a protocol (http:, https:, javascript:, data:, etc.)
        if (/^[a-z][a-z0-9+.-]*:/i.test(url)) return false;

        // Optionally, reject URLs containing "@" (to avoid user:pass@host)
        if (url.includes('@')) return false;

        // Passed all checks, treat as safe relative URL
        return true;
    }

    bindAutoComplete() {
        const cleanPageId = this.pageId.replace(/{|}/g, "");
        const autoSuggestionUrl = this.autoSuggestionEndpoint.replace("[itemId]", cleanPageId).replace("[version]", this.pageVersion).replace("[siteName]", this.siteName).replace("[language]", this.language);
        const autoSuggestionBody = this.autoSuggestionBody.replace("[queryOverride]", this.query);
        const searchInput = this.searchInput;

        const self = this;

        this.searchInput.setAttribute("aria-controls", "header-autocomplete-list");

        // Initialize jQuery UI Autocomplete
        $(this.searchInputSelector).autocomplete({
            source: (request, response) => {
                const headers = {
                    Accept: "application/json",
                    Authorization: `Bearer ${self.bearerToken}`,
                };

                const queryText = request.term;
                let body = autoSuggestionBody.replace("[term]", queryText);

                fetch(autoSuggestionUrl, {
                    headers: headers,
                    body: body,
                    method: "POST",
                })
                    .then((res) => {
                        return res.json();
                    })
                    .then((data) => {
                        const suggestions = Array.isArray(data.values)
                            ? data.values.map((item) => ({
                                label: item.value,
                                value: item.value,
                            }))
                            : [];
                        response(suggestions);
                    })
                    .catch((error) => {
                        console.error("Error fetching suggestions:", error);
                        response([]);
                    });
            },
            appendTo: this.autosuggestionContainer,
            minLength: 1,
            classes: {
                "ui-autocomplete": "E-search-panel__autocomplete"
            },
            open: function (event, ui) {
                searchInput.setAttribute("aria-expanded", "true");
                $(this).autocomplete("widget").attr("id", "header-autocomplete-list");
                self.recentSearchesContainer.style.display = "none";
            },
            close: function (event, ui) {
                searchInput.setAttribute("aria-expanded", "false");
                //check if child li exists in recentSearchesContainer
                if (self.recentSearchesContainer.querySelector("li")) {
                    self.recentSearchesContainer.style.display = "";
                }
            },
            select: (event, ui) => {
                this.redirectToSearchPage(ui.item.value);
            },
        }).data("ui-autocomplete")._renderItem = function (ul, item) {
            const term = this.term.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"); // escape special characters
            const regex = new RegExp("(" + term + ")", "gi");
            const label = item.label.replace(regex, "<mark>$1</mark>");

            return $("<li>")
                .attr("data-value", item.value)
                .append(label)
                .appendTo(ul);
        };
    }

    getBearerToken() {
        //get current datetime tick
        const currentDateTimeTick = new Date().getTime();
        //get bearer token from server
        const bearerTokenEndpoint = `${this.bearerTokenEndpoint}${currentDateTimeTick}`;

        fetch(bearerTokenEndpoint, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Bearer token request failed: ${response.status} ${response.statusText}`);
                }
                return response.json();
            })
            .then((data) => {
                this.bearerToken = data.token;
            })
            .catch((error) => {
                console.error("Error fetching bearer token:", error);
            });;
    }

    loadRequiredAssets() {
        if (this.jQueryUiLoaded) {
            return;
        }

        if (typeof jQuery.ui !== 'undefined') {
            this.bindAutoComplete();
            return;
        }

        const jQueryUiJs = document.createElement("script");
        jQueryUiJs.src = this.jQueryUiJsPath;
        jQueryUiJs.onload = () => {
            this.bindAutoComplete();
        };
        document.body.appendChild(jQueryUiJs);
        this.jQueryUiLoaded = true;
    }

    redirectToSearchPage(queryText) {
        let searchUrl = this.searchPageUrl;

        // Ensure the searchPageUrl is safe before proceeding
        if (!this.isSafeRelativeUrl(this.searchPageUrl)) {
            return; // Do not proceed if the URL is unsafe
        }
    
        if (queryText) {
            // Simple sanitize: encode input to ensure it's safe in URLs
            const safeQuery = encodeURIComponent(queryText);
        
            // Add hash fragment safely
            searchUrl += `#q=${safeQuery}`;
        }
    
        window.location.href = searchUrl;
    }    

    showSearchSection() {
        const $searchIcon = $(this.searchIconSelector);
        $searchIcon.toggleClass("--is-active");
        $(this.mainNavTriggerSelector).removeClass("--is-active");

        const targetId = $searchIcon.attr("aria-controls");
        const $targetElement = $("#" + targetId);

        if ($targetElement.length) {
            const isNowActive = $targetElement.toggleClass("--is-active").hasClass("--is-active");

            if (isNowActive) {
                const $firstFocusable = $targetElement.find('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])').first();
                if ($firstFocusable.length) {
                    $firstFocusable[0].focus();
                } else {
                    $targetElement.attr('tabindex', '-1')[0].focus();
                }
            }
        }

        // Update aria-expanded attribute
        const isExpanded = $searchIcon.hasClass("--is-active");
        $searchIcon.attr("aria-expanded", isExpanded);
    }

    hideSearchSection() {
        this.searchInput.value = "";
        $(this.searchSection).removeClass("--is-active");

        if ($(this.searchIconSelector).length) {
            // Set controller to inactive state
            $(this.searchIconSelector).removeClass("--is-active");
            $(this.searchIconSelector).attr("aria-expanded", false);

            // Return focus to the controller element
            $(this.searchIconSelector).focus();
        }
    }

    getCookieValue(cookieName) {
        const name = cookieName + "=";
        const cookies = document.cookie.split(';');
        for (let c of cookies) {
            c = c.trim();
            if (c.startsWith(name)) {
                return decodeURIComponent(c.substring(name.length));
            }
        }
        return "";
    }

    setRecentSearches() {
        const cookieValue = this.getCookieValue("Exxon-last-searches");
        if (!cookieValue) {
            return;
        }

        try {
            const recentSearches = JSON.parse(cookieValue);
            if (!Array.isArray(recentSearches)) {
                return;
            }
            if (recentSearches.length === 0) {
                return;
            }
            //show the recent searches container
            this.recentSearchesContainer.style.display = "";

            //loopthrough the array of objects
            recentSearches.forEach((item, index) => {
            let searchText = decodeURIComponent(item.SearchText);        
            // Strip suspicious protocols (defense-in-depth)
            if (/^(javascript|data|vbscript):/i.test(searchText)) {
                return; // skip this item
            }

                const li = document.createElement("li");
                const a = document.createElement("a");

                // Ensure the searchPageUrl is safe before proceeding
                if (!this.isSafeRelativeUrl(this.searchPageUrl)) {
                    return; // Skip adding this search item if the URL is unsafe
                }

                a.href = `${this.searchPageUrl}#q=${encodeURIComponent(searchText)}`;
                // Add comma after text except for the last item
                a.textContent = searchText;
                li.appendChild(a);
                if (this.recentSearchesUl) {
                    this.recentSearchesUl.appendChild(li);
                }
            });
        } catch (e) {
            console.error("Invalid JSON string:", e.message);
        }
    }
}

const headerCoveoSearch = new HeaderCoveoSearch();
headerCoveoSearch.init();
$(window).on("load", function () {
    if (typeof consentManager === "undefined" ||
        !consentManager.isCategoryActive("CoveoSearch")) {
        return;
    }

    //set the recent searches
    headerCoveoSearch.setRecentSearches();
});